// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ListPageContent_Lazy$Showside from "../components/ListPageContent_Lazy.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageScrollableWrapper$Showside from "../components/ListPageScrollableWrapper.bs.js";
function ListPageWithLazyContent(Props) {
  var scrollableContainerRef = Props.scrollableContainerRef;
  var drawerState = Props.drawerState;
  var anchorHookResult = Props.anchorHookResult;
  var listPageContent = Props.listPageContent;
  var children = Props.children;
  var routerProvider = RouterProvider$Showside.useRouter(undefined);
  var configurationProvider = ConfigurationProvider$Showside.use(undefined);
  var entrypointContext = EntrypointContext$Showside.use(undefined);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, configurationProvider.config.categories);
  var innerContainerRef = React.useRef(null);
  var show;
  if (drawerState !== 0) {
    var tmp = {
      scrollableContainerRef: scrollableContainerRef,
      isSidebarOpen: entrypointContext.isSidebarOpen,
      isMobileFiltersOpen: entrypointContext.isMobileFiltersOpen
    };
    if (activeCategory !== undefined) {
      tmp.activeCategory = Caml_option.valFromOption(activeCategory);
    }
    if (anchorHookResult !== undefined) {
      tmp.anchorHookResult = Caml_option.valFromOption(anchorHookResult);
    }
    show = Belt_Option.getWithDefault(listPageContent, React.createElement(ListPageContent_Lazy$Showside.make, tmp));
  } else {
    show = null;
  }
  return React.createElement(ErrorBoundary$Showside.make, {
    componentName: "ListPage",
    redirect: routerProvider.back,
    children: React.createElement(ListPageScrollableWrapper$Showside.make, {
      useWindow: entrypointContext.embedType === /* Inline */1,
      anchorHookResult: anchorHookResult,
      scrollableContainerRef: scrollableContainerRef,
      innerContainerRef: innerContainerRef,
      children: React.createElement("div", {
        ref: ReactDOMUtils$Showside.Ref.domRef(innerContainerRef),
        className: CSS$Showside.prefix(Cn.make(["smartnav-layout", "grid", "bg-main", "relative", "z-0"]))
      }, children, show)
    })
  });
}
ListPageWithLazyContent.displayName = "ListPageWithLazyContent";
var make = ListPageWithLazyContent;
export { make };
/* react Not a pure module */